export default class ResponsiveVideo {
    constructor(el) {
        // if el doesn't exist
        if (!el) return;
        this.el = el;

        this.init();
    }

    init() {
        let windowWidth = window.innerWidth
        if (windowWidth > 767 ) {
            this.addSourceToVideo( this.el, this.el.dataset.desktopVid);
            if(this.el.dataset.desktopPoster) {
                this.setVideoPoster( this.el, this.el.dataset.desktopPoster);
            }
        } else {
            this.addSourceToVideo( this.el, this.el.dataset.mobileVid);
            if(this.el.dataset.mobilePoster) {
                this.setVideoPoster( this.el, this.el.dataset.mobilePoster);
            }
        }       
    }

    addSourceToVideo(el, src) {
        let source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        el.appendChild(source);
    }

    setVideoPoster(el, src) {
        el.poster = src;
    }
}
